module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/325.8b7ae1e3.png";